import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Box, Tooltip, Typography } from "@mui/material";
import { fakeReasonText } from "./messageContent";
import { EFakeReportState } from "./types";
var HTTP_OK = 200;
/**
 * The delivery report the fake posted for a message and what the webhook
 * component answered: ✓✓ for 200, otherwise the status or why it wasn't
 * posted, so a refused report is visible rather than silent.
 */
export var ReportResult = function (_a) {
    var _b;
    var report = _a.report;
    var t = useTranslation().t;
    if (!report || report.state === EFakeReportState.NO_RECEIPTS) {
        return (_jsx(Typography, { variant: "caption", color: "text.secondary", children: t("sentMessages.report.unavailable") }));
    }
    if (report.state === EFakeReportState.ANSWERED && report.status === HTTP_OK) {
        var label = t("sentMessages.report.accepted");
        return (_jsx(Tooltip, { title: label, children: _jsx(Box, { component: "span", role: "img", "aria-label": label, sx: {
                    color: "info.main",
                    fontWeight: 700,
                    letterSpacing: "-0.2em",
                    fontSize: "0.85rem",
                }, children: "\u2713\u2713" }) }));
    }
    var pending = report.state === EFakeReportState.PENDING;
    var text = pending
        ? t("sentMessages.report.pending")
        : report.state === EFakeReportState.ANSWERED
            ? t("sentMessages.report.refused", { status: (_b = report.status) !== null && _b !== void 0 ? _b : "?" })
            : report.state === EFakeReportState.NOT_SENT
                ? t("sentMessages.report.notSent", { reason: fakeReasonText(t, report.reason) })
                : t("sentMessages.report.noAnswer", { reason: fakeReasonText(t, report.reason) });
    return (_jsx(Typography, { variant: "caption", sx: { color: pending ? "text.secondary" : "error.dark", fontWeight: pending ? 400 : 600 }, children: text }));
};
